import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import FlowList from './components/FlowList';
import FlowEditor from './components/FlowEditor';
import UserManagement from './components/UserManagement';
import './App.css';

// Componente de proteção de rotas
function ProtectedRoute({ children }) {
  const token = localStorage.getItem('zaptime_token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
}

// Componente de proteção para rotas de admin
function AdminRoute({ children }) {
  const token = localStorage.getItem('zaptime_token');
  const user = JSON.parse(localStorage.getItem('zaptime_user') || '{}');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  if (user.username !== 'admin') {
    return <Navigate to="/" replace />;
  }
  
  return children;
}

function App() {
  return (
    <Router>
      <Routes>
        {/* Rota de Login */}
        <Route path="/login" element={<Login />} />
        
        {/* Rota Principal (Dashboard) */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        
        {/* Rotas do Sistema de Fluxos */}
        <Route 
          path="/flows" 
          element={
            <ProtectedRoute>
              <FlowList />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/flow-editor" 
          element={
            <ProtectedRoute>
              <FlowEditor />
            </ProtectedRoute>
          } 
        />
        
        <Route 
          path="/flow-editor/:id" 
          element={
            <ProtectedRoute>
              <FlowEditor />
            </ProtectedRoute>
          } 
        />
        
        {/* Rota de Gerenciamento de Usuários (apenas admin) */}
        <Route 
          path="/users" 
          element={
            <AdminRoute>
              <UserManagement />
            </AdminRoute>
          } 
        />
        
        {/* Redirecionar rotas não encontradas */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
